const prefix = 'sprintSubscriptions';

export const FIND = `${prefix}/FIND`;
export const FETCH_ALL = `${prefix}/FETCH_ALL`;
export const UPDATE_PLAN = `${prefix}/UPDATE_PLAN`;
export const UPDATE = `${prefix}/UPDATE`;
